export default __webpack_public_path__ + "static/media/Study-Guide.c514e3fa.png";